import React, {useState, useEffect} from "react";
import {
    TextField, InputAdornment, Typography, Box, Paper,
    Pagination, useTheme
} from "@mui/material";
import CustomButton from "../../../core/components/ui/CustomButton";
import CustomTypography from "../../../core/components/ui/CustomTypography";
import AddIcon from "@mui/icons-material/Add";
import GenerateSingleGatePassDialog from "../components/generate-single-gate-pass.dialog";
import useGatePass from "../hooks/useGatePass";
import useGatePassStore from "../zustand/useGatePassStore";
import CustomTableLoaderComponent from "../../../core/components/common/custom-table-loader.component";
import ListGatePassComponent from "../components/list-gate-pass.component";
import {useNavigate, useLocation} from "react-router-dom";
import { RBACUIGuard } from "../../RBACPlugin";
import { permissions } from "../../../core/components/common/variables/static_variables";
import CustomFilterComponent from "../../../core/components/common/custom-filter.component";
import useUserProfile from "../../ProfilePlugin/hooks/useUserProfile";

const headers = ["Plate Number", "Pass Type", "Entry Type", "Validity", "Status", "Actions"];



const GatePassPage = (props) => {

    const rbacStorage = JSON.parse(localStorage.getItem("rbac-storage"));
    const org_uid = rbacStorage?.state?.currentProfile?.orgId || null;

    const view_org_uid = new URLSearchParams(window.location.search).get("org_uid");

    const organizationId = view_org_uid || org_uid;

    const {isMobile, breakpoints} = props;
    const theme = useTheme();
    const navigate = useNavigate();
    const {viewProfile, profileDetails} = useUserProfile();

    const {
        isFetchingGatePassList,
        gatePassListData,
        listGatePass,
        isFilteringGatePass,
        filterGatePass,
        passTypeList,
        getGatePassPassType,
        entryTypeList,
        getGatePassEntryType,
    } = useGatePass();


    const {isGatePassCreated, isGatePassStatusUpdated} = useGatePassStore();

    const [gatePassList, setGatePassList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [open, setOpen] = useState(false);

    const [filterLabel, setFilterLabel] = useState(null);
    const [filter, setFilter] = useState(null);
    const [plateNumberFilterValue, setPlateNumberFilterValue] = useState(null);
    const [passTypeFilterValue, setPassTypeFilterValue] = useState(null);
    const [entryTypeFilterValue, setEntryTypeFilterValue] = useState(null);
    const [statusFilterValue, setStatusFilterValue] = useState(null);

    const [passTypeData, setPassTypeData] = useState([]);
    const [entryTypeData, setEntryTypeData] = useState([]);

    const rowsPerPage = 10;

    const gatePassStatusListData = [
        {value: "For Approval", label: "For Approval"},
        {value: "Active", label: "Active"},
        {value: "Suspended", label: "Suspended"},
        {value: "Denied", label: "Denied"},
        {value: "Deactivated", label: "Deactivated"},
    ];

    const searchForOptions = [
        {value: "plate_number", label: "Plate Number"},
        {value: "entry_type", label: "Entry Type"},
        {value: "pass_type", label: "Pass Type"},
        {value: "status", label: "Status"},
    ];

    useEffect(() => {
        viewProfile();
    }, []);

    useEffect(() => {
        if (filter) return;
        const parameters = {
            page: currentPage,
            limit: rowsPerPage,
            orgUID: organizationId,
        };

        listGatePass(parameters);
       
    }, [organizationId, currentPage]);

    useEffect(() => {
        const parameters = {
            page: currentPage,
            limit: rowsPerPage,
            orgUID: organizationId,
        };
        getGatePassPassType(parameters);
        getGatePassEntryType(parameters);
    },[organizationId, currentPage])


    useEffect(() => {
        if (passTypeList) {
            const formattedPassTypes = passTypeList.map((type) => ({
                value: type.toLowerCase(),
                label: type,
            }));
            setPassTypeData(formattedPassTypes);
        }
    }, [passTypeList]);

    useEffect(() => {
        if (entryTypeList) {
            const formattedEntryTypes = entryTypeList.map((status) => ({
                value: status.toLowerCase(),
                label: status,
            }));
            setEntryTypeData(formattedEntryTypes);
        }
    }, [entryTypeList]);

    useEffect(() => {
        setGatePassList(gatePassListData?.content);
        setTotalPages(gatePassListData?.totalPages);
    }, [gatePassListData]);

    useEffect(() => {
        const parameters = {
            page: 1,
            limit: rowsPerPage,
            orgUID: organizationId,
        };
        if(isGatePassCreated || isGatePassStatusUpdated) {
            listGatePass(parameters);
        }
    }, [currentPage, isGatePassCreated, isGatePassStatusUpdated]);

    useEffect(() => {
        const commonParams = {
            page: currentPage,
            limit: 20,
            searchFor: filter,
            orgUID: organizationId,
        };

        if (filter && passTypeFilterValue) {
            filterGatePass({...commonParams, searchVal: passTypeFilterValue});
        } else if (filter && entryTypeFilterValue) {
            filterGatePass({...commonParams, searchVal: entryTypeFilterValue});
        } else if (filter && statusFilterValue) {
            filterGatePass({...commonParams, searchVal: statusFilterValue});
        }
    }, [passTypeFilterValue, entryTypeFilterValue, statusFilterValue, organizationId, currentPage]);

    const handleChangePagination = (event, page) => {
        setCurrentPage(page);
    };

    const handleSearchForOption = (selectedOption, type) => {

        console.log('selected type',type)
        if (selectedOption && type === "pass_type") {
            setFilter(selectedOption.value);
            setFilterLabel(selectedOption.label);
            setEntryTypeFilterValue(null);
            setStatusFilterValue(null);
        } else if (selectedOption && type === "entry_type") {
            setFilter(selectedOption.value);
            setFilterLabel(selectedOption.label);
            setPassTypeFilterValue(null);
            setStatusFilterValue(null);
        } else if (selectedOption && type === "status") {
            setFilter(selectedOption.value);
            setFilterLabel(selectedOption.label);
            setPassTypeFilterValue(null);
            setEntryTypeFilterValue(null);
        } else if (selectedOption && type === "plate_number") {
            setFilter(selectedOption.value);
            setFilterLabel(selectedOption.label);
            setPassTypeFilterValue(null);
            setEntryTypeFilterValue(null);
            setStatusFilterValue(null);
        } else {
            handleSearchForClearFilter();
        }
    };

    const handleSearchForClearFilter = () => {
        setFilter(null);
        setFilterLabel(null);

        const parameters = {
            page: 1,
            limit: rowsPerPage,
            orgUID: organizationId
        };

        listGatePass(parameters);
    };

    const handleSearchValOption = (selectedOption, type) => {
        if (selectedOption && type === "passType") {
            setPassTypeFilterValue(selectedOption.label);
            setEntryTypeFilterValue(null);
            setStatusFilterValue(null);
        } else if (selectedOption && type === "entryType") {
            setEntryTypeFilterValue(selectedOption.label);
            setPassTypeFilterValue(null);
            setStatusFilterValue(null);
        } else if (selectedOption && type === "status") {
            setStatusFilterValue(selectedOption.label);
            setPassTypeFilterValue(null);
            setEntryTypeFilterValue(null);
        } else {
            handleSearchValClearFilter();
        }
    };

    const handleSearchValClearFilter = () => {
        setPassTypeFilterValue(null);
        setEntryTypeFilterValue(null);
        setStatusFilterValue(null);
        setPlateNumberFilterValue("");

        listGatePass({
            page: 1,
            limit: rowsPerPage,
            orgUID: organizationId
        });
    };

    const handleTextfield = (e) => {
        setPassTypeFilterValue(null);
        setEntryTypeFilterValue(null);
        setStatusFilterValue(null);
        setPlateNumberFilterValue(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.keyCode === 13) {
            if (filter && plateNumberFilterValue) {
                const parameters = {
                    page: 1,
                    limit: 20,
                    searchFor: filter,
                    searchVal: plateNumberFilterValue,
                    orgUID: organizationId
                };
                filterGatePass(parameters);
            }
        }
    };

    console.log('getttttt', entryTypeData)

    let create_gatepass = '/gatepass/create';

    if (!org_uid && view_org_uid) {
        create_gatepass = `/organization/view/gatepass/create?org_uid=${view_org_uid}`;
    }


    return (
        <>
            <Box sx={{textAlign: "start"}}>
                <CustomTypography variant="h3" text="Gate Pass" customStyles={{marginBottom: 0}} />
                <CustomTypography
                    variant="subtitle1"
                    text="Manage, update and generate gate passes while monitoring access activities in real-time"
                    customStyles={{marginBottom: 0}}
                />
            </Box>

            <Paper elevation={0} sx={{border: "1px solid #e5edf6", borderRadius: 2, padding: "24px 32px", mt: 3}}>
                <Box sx={{display: "flex", justifyContent: "right"}}>
                    <CustomFilterComponent
                        width={200}
                        isSearchable
                        isClearable
                        filterLabel={filterLabel}
                        filterOptions={searchForOptions}
                        onChange={(option) => handleSearchForOption(option, option?.value)}
                        isSearchForFilter
                        isSearchValue={false}
                    />

                    {(filterLabel === null || filterLabel === "Pass Type") && (
                        <CustomFilterComponent
                            width={300}
                            isSearchable
                            isClearable
                            filterLabel={filterLabel}
                            filterOptions={passTypeData}
                            onChange={(opt) => handleSearchValOption(opt, "passType")}
                            isSearchForFilter={false}
                            isSearchValue
                        />
                    )}

                    {(filterLabel === "Entry Type") && (
                        <CustomFilterComponent
                            width={300}
                            isSearchable
                            isClearable
                            filterLabel={filterLabel}
                            filterOptions={entryTypeData}
                            onChange={(opt) => handleSearchValOption(opt, "entryType")}
                            isSearchForFilter={false}
                            isSearchValue
                        />
                    )}

                    {(filterLabel === "Status") && (
                        <CustomFilterComponent
                            width={300}
                            isSearchable
                            isClearable
                            filterLabel={filterLabel}
                            filterOptions={gatePassStatusListData}
                            onChange={(opt) => handleSearchValOption(opt, "status")}
                            isSearchForFilter={false}
                            isSearchValue
                        />
                    )}

                    {(filterLabel === "Plate Number") && (
                        <TextField
                            value={plateNumberFilterValue}
                            placeholder="Input Plate Number..."
                            variant="outlined"
                            autoComplete="off"
                            onChange={handleTextfield}
                            onKeyDown={handleKeyPress}
                            slotProps={{
                                input: {
                                    style: {
                                        padding: "10px",
                                        fontSize: 14,
                                        fontStyle: "italic"
                                    },
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Typography sx={{
                                                fontSize: 14,
                                                color: theme.typography.primary,
                                                opacity: 0.85,
                                                fontStyle: "normal"
                                            }}>
                                                Plate Number:
                                            </Typography>
                                        </InputAdornment>
                                    )
                                }
                            }}
                            sx={{
                                marginRight: "10px",
                                "& .MuiInputBase-root": {
                                    height: 42,
                                    backgroundColor: "transparent",
                                    width: 300,
                                    borderColor: "#dce8f5"
                                },
                                "& .MuiOutlinedInput-root": {
                                    height: 42,
                                    backgroundColor: "transparent",
                                    "& fieldset": {borderColor: "#dce8f5"},
                                    "&:hover fieldset": {borderColor: theme.palette.primary.main},
                                    "&.Mui-focused fieldset": {
                                        borderColor: `0 0 0 1px ${theme.palette.primary.main}`
                                    }
                                }
                            }}
                        />
                    )}

                    <RBACUIGuard requiredPermission={permissions.gatepass.GENERATE_VEHICLE_GATEPASS}>
                        <CustomButton
                            variant="contained"
                            startIcon={<AddIcon fontSize="small" />}
                            label="Generate Gate Pass"
                            customStyles={{fontSize: 14}}
                            onClick={() => navigate(create_gatepass)}
                        />
                    </RBACUIGuard>
                </Box>

                {(isFetchingGatePassList || isFilteringGatePass) ? (
                    <Box sx={{mt: 3}}>
                        <CustomTableLoaderComponent headers={headers} hasAction={false} />
                    </Box>
                ) : (
                    <Box sx={{mt: 3, mb: (!gatePassList?.length) ? 2 : {}}}>
                        <ListGatePassComponent
                            headers={headers}
                            data={gatePassList}
                            isMobile={isMobile}
                            breakpoints={breakpoints}
                            organizationId={org_uid ? org_uid : view_org_uid}
                        />

                        {gatePassList?.length > 0 && (
                            <Pagination
                                count={totalPages}
                                page={currentPage}
                                onChange={handleChangePagination}
                                sx={{
                                    margin: "auto",
                                    width: "fit-content",
                                    paddingTop: 3,
                                    "& .MuiPaginationItem-root.Mui-selected": {
                                        backgroundColor: "#0b99da",
                                        color: "#fff"
                                    }
                                }}
                            />
                        )}
                    </Box>
                )}

                {open && (
                    <GenerateSingleGatePassDialog
                        open={open}
                        setOpen={setOpen}
                        organizationId={organizationId}
                    />
                )}
            </Paper>
        </>
    );
};

export default GatePassPage;
